import React, { useState, useEffect, useRef } from 'react';
import './chatbot-styles.css';
import ChatInput from './ChatInput';
import ChatOutput from './ChatOutput';
import ChatService from './ChatService';

const Chatbot = () => {
  const { fetchChatbotResponse } = ChatService();
  const [userInput, setUserInput] = useState('');
  const [messages, setMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const chatOutputRef = useRef(null);

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const scrollToBottom = () => {
    if (chatOutputRef.current) {
      chatOutputRef.current.scrollTop = chatOutputRef.current.scrollHeight;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (userInput.trim()) {
      const newMessages = [...messages, { user: 'You', text: userInput }];
      setMessages(newMessages);
      setIsLoading(true);

      try {
        const response = await fetchChatbotResponse(userInput, newMessages.map((message) => message.text));
        setMessages([...newMessages, { user: 'Chatbot', text: response }]);
      } catch (error) {
        setMessages([...newMessages, { user: 'Chatbot', text: 'An error occurred. Please try again later.' }]);
      }

      setUserInput('');
      setIsLoading(false);
    }
  };

  const handleInputChange = (e) => {
    setUserInput(e.target.value);
  };

  return (
    <div>
      <main>
        <h1>Welcome to my Chatbot</h1>
        <div className="chat-container" id="chat-container">
          <ChatOutput messages={messages} isLoading={isLoading} ref={chatOutputRef} />
          <ChatInput
            userInput={userInput}
            handleInputChange={handleInputChange}
            handleSubmit={handleSubmit}
            isLoading={isLoading}
          />
        </div>
      </main>
    </div>
  );
};

export default Chatbot;